export const SportIcons = {
	AFL: 'afl',
	'American football': 'uniE95D',
	Archery: 'uniE93A',
	Badminton: 'badminton',
	Baseball: 'baseball',
	Basketball: 'basketball',
	Boxing: 'boxing',
	'Car racing': 'uniE952',
	Cards: 'cards',
	Casino: 'uniE91C',
	Cricket: 'cricket',
	Curling: 'curling',
	Cycling: 'cycling',
	Darts: 'darts',
	Equestrian: 'equestrian',
	Esports: 'esports',
	Film: 'film',
	Football: 'football',
	'Formula one': 'steering-wheel',
	Gallop: 'gallop',
	'Gaelic football': 'uniE92A',
	'Gaelic sports': 'gaelic-sports',
	Golf: 'golf',
	Greyhound: 'greyhound',
	'Ice hockey': 'ice-hockey',
	NFL: 'nfl',
	Handball: 'uniE92F',
	Harness: 'harness',
	Hockey: 'hockey',
	'Horse racing': 'horse-racing',
	Lacrosse: 'uniE95E',
	'Lawn bowls': 'lawn-bowls',
	Live: 'live-event',
	Medal: 'medal',
	MMA: 'mma',
	Motorsports: 'motor-sport',
	Netball: 'uniE969',
	NHL: 'uniE944',
	'Olympic torch': 'uniE94B',
	Polo: 'uniE961',
	Rowing: 'rowing',
	'Rugby league': 'uniE954',
	'Rugby union': 'rugby-union',
	Running: 'uniE90A',
	Sailing: 'sailing',
	'Sheep sheering': 'uniE959',
	Skiing: 'skiing',
	Snooker: 'snooker',
	Softball: 'uniE95C',
	Stadium: 'stadium',
	Sumo: 'sumo',
	Surfing: 'surfing',
	Swimming: 'swimming',
	'Table tennis': 'table-tennis',
	Tennis: 'tennis',
	Triathlon: 'triathlon',
	Volleyball: 'volleyball',
	Voting: 'voting',
	'Water polo': 'water-polo'
};

export const OtherIcons = {
	Live: 'live',
	'Next up': 'next-up',
	Playbook: 'playbook',
	'Playup star circle': 'playup-star-circle',
	'Playup star': 'playup-star',
	Profile: 'profile',
	'Chevron down': 'chevron-down',
	'Chevron left': 'chevron-left',
	'Chevron right': 'chevron-right',
	'Chevron up': 'chevron-up',
	Receipt: 'uniE90F',
	Gift: 'gift',
	'Boost up': 'boost-up',
	Hamburger: 'hamburger',
	Calendar: 'calendar',
	Cross: 'uniE916',
	Edit: 'uniE91D',
	Voting: 'voting',
	Email: 'email',
	Film: 'film',
	'External link': 'uniE923',
	Help: 'uniE924',
	Phone: 'phone',
	Filter: 'filter',
	Statistics: 'uniE928',
	World: 'uniE92B',
	Hide: 'hide',
	Home: 'home',
	Instagram: 'instagram',
	Information: 'uniE937',
	Location: 'location',
	Login: 'uniE93C',
	Logout: 'uniE93D',
	'Arrow right': 'arrow-right',
	'Arrow down': 'arrow-down',
	'Arrow left': 'arrow-left',
	'Arrow up': 'arrow-up',
	Clock: 'uniE94D',
	Refresh: 'uniE953',
	Search: 'uniE957',
	Settings: 'uniE958',
	Star: 'uniE95F',
	'Star outline': 'uniE960',
	Bin: 'bin',
	Twitter: 'twitter',
	Youtube: 'youtube',
	'Meatball menu': 'uniE940',
	'Bonus back': 'bonus-back'
};

export const Icons = { ...OtherIcons, ...SportIcons };
